define('view/controller/booking/provider/ProviderStepLayout',['require','lib/view/LayoutView','backbone','view/controller/booking/provider/ProviderStepView','view/controller/booking/provider/ProviderFilterView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Model = require('backbone').Model;
    var ProviderStepView = require('view/controller/booking/provider/ProviderStepView');
    var ProviderFilterView = require('view/controller/booking/provider/ProviderFilterView');
    var Config = require('Config');

    /**
     * Provider Step Layout
     *
     * @class ProviderStepLayout
     */
    return LayoutView.extend({

        template: '#provider_step_layout',
        regions: {
            list: '.sb-list-container',
            filter: '.sb-filter-container',
        },

        initialize: function () {
            this._collection = this.getOption('collection');

            this.filterModel = new Model({
                query: ''
            });
        },

        onRender: function () {
            var listView = new ProviderStepView({
                collection: this._collection,
                filterModel: this.filterModel
            });
            this.showChildView('list', listView);

            var providerCount = Config.getInstance().getOption('provider_count');

            if (Config.getInstance().getPluginStatus('any_unit')) {
                if (Config.getInstance().getOption('any_unit_hide_other_units')) {
                    providerCount = 1;
                } else {
                    providerCount++;
                }
            }

            if (providerCount > 5) {
                var filterView = new ProviderFilterView({
                    model: this.filterModel
                });
                this.showChildView('filter', filterView);
            }
        }

    });

});
